export const AHT_DOSE_LABELS: Record<string, Record<string, string>> = {
  tirzepatide: {
    "tzp-2_5mg":  "2.5 mg SC once weekly",
    "tzp-5mg":    "5 mg SC once weekly",
    "tzp-7_5mg":  "7.5 mg SC once weekly",
    "tzp-10mg":   "10 mg SC once weekly",
    "tzp-12_5mg": "12.5 mg SC once weekly",
    "tzp-15mg":   "15 mg SC once weekly",
  },
  semaglutide: {
    "sem-0_25mg": "0.25 mg SC once weekly",
    "sem-0_5mg":  "0.5 mg SC once weekly",
    "sem-1_0mg":  "1.0 mg SC once weekly",
    "sem-1_7mg":  "1.7 mg SC once weekly",
    "sem-2_4mg":  "2.4 mg SC once weekly",
  },
  liraglutide: {
    "lira-0_6mg": "0.6 mg SC once daily",
    "lira-1_2mg": "1.2 mg SC once daily",
    "lira-1_8mg": "1.8 mg SC once daily",
    "lira-2_4mg": "2.4 mg SC once daily",
    "lira-3_0mg": "3.0 mg SC once daily",
  },
};

export function lookupDoseLabel(drugRef: string, optionId: string): string | undefined {
  return AHT_DOSE_LABELS[drugRef]?.[optionId];
}
